import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import { URL } from "modules/utils/Common";

const FinancialContext = React.createContext({
  state: { financialList: {}, financial: {} },
  actions: {
    getFinancial: () => {},
    getFinancialList: () => {},
  },
});

const FinancialProvider = ({ children }) => {
  const [financial, setFinancial] = useState({});
  const [financialList, setFinancialList] = useState([]);

  const getFinancialList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/financial/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        displayYn: pageInfo && pageInfo.displayYn,
        financialTitle: pageInfo && pageInfo.financialTitle,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFinancialList(res.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getFinancial = useCallback((financialId) => {
    HttpAction({
      url: "api/admin/financial",
      method: "get",
      params: {
        financialId: financialId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFinancial(res.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createFinancial = useCallback(async (financialData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/financial/save`, financialData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getFinancialList({ page: 1, records: 10 });
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateFinancial = useCallback(async (financialData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/financial/modify`, financialData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getFinancialList({ page: 1, records: 10 });
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const deleteFinancial = useCallback((financialId, history) => {
    HttpAction({
      url: "api/admin/financial",
      method: "delete",
      params: {
        financialId: financialId,
      },
    }).then((res) => {
      if (res.code === 200) {
        history.push(`${URL.ADMIN_BASE_URL}/company/financialinfo`);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { financial, financialList },
    actions: {
      getFinancialList,
      getFinancial,
      createFinancial,
      updateFinancial,
      deleteFinancial,
    },
  };

  return (
    <FinancialContext.Provider value={value}>
      {children}
    </FinancialContext.Provider>
  );
};

const { Consumer: FinancialConsumer } = FinancialContext;

export { FinancialProvider, FinancialConsumer, FinancialContext };

export default FinancialContext;
